import React, {Component} from 'react';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField/index';
import Paper from '@material-ui/core/Paper/index';
import MenuItem from '@material-ui/core/MenuItem/index';
import {withStyles} from '@material-ui/core/styles/index';

const styles = theme => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(0.5),
        zIndex: 10,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(0.5),
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing(2),
    },
    textField: {
        marginTop: 0,
        '& fieldset': {
            border: theme.input && theme.input.border + '!important',
            background: '#fff',
        },
    },
    suggestionItem: {
        width: '100%',
        [theme.breakpoints.up(400)]: {
            display: 'flex',
        }
    },
    suggestionCompanyName: {},
    suggestionBusinessId: {
        marginLeft: 'auto',
        color: 'grey',
        [theme.breakpoints.up(400)]: {
            paddingLeft: 8,
        },
        [theme.breakpoints.down(400)]: {
            fontSize: '0.8rem',
            marginTop: -6,
        }
    },
});

class AutoSuggest extends Component {

    state = {single: '', stateSuggestions: [], selectedSuggestion: null, allSuggestions: []}

    componentDidMount() {
        this.updateTimeout = null
    }

    handleSuggestionsFetchRequested = ({value}) => {
        this.getSuggestions(value);
    };

    handleSuggestionsClearRequested = () => {
        this.setSuggestions([]);
    };

    handleChange = name => (event, {newValue}) => {
        this.setState({
            ...this.state,
            [name]: newValue,
        });
    };

    setSuggestions = (value) => {
        this.setState({stateSuggestions: value, allSuggestions: [...this.state.allSuggestions, ...value]})
    }

    getSuggestions = (value) => {
        clearTimeout(this.updateTimeout)
        this.updateTimeout = setTimeout(() => {
            const serverSuggestions = this.props.getSuggestions(value).then((data) => {
                if (data.notFound) {
                    this.props.companyNotFound(value);
                    this.setSuggestions([])
                    return;
                }
                this.props.companiesFound(value);
                this.setSuggestions(data)
            })
        }, 200)
    }

    onSuggestionSelected = (event, {suggestion}) => {
        this.props.onChange(suggestion)
        this.setState({single: ''})
    }

    render() {
        const {classes} = this.props;

        const {single, stateSuggestions} = this.state;

        const getSuggestionValue = (suggestion) => {
            return suggestion.name;
        }

        const renderInputComponent = (inputProps) => {
            const {
                classes, inputRef = () => {
                }, ref, ...other
            } = inputProps;

            return (
                <TextField
                    fullWidth
                    error={this.props.valid === false}
                    variant={this.props.question.variant}
                    className={classes.textField + ' inputText ' + (this.props.question.variant === 'outlined' ? 'outlinedInputText' : '')}
                    InputProps={{
                        inputRef: node => {
                            ref(node);
                            inputRef(node);
                        },
                        classes: {
                            input: classes.input,
                        },
                    }}
                    {...other}
                />
            );
        }

        const renderSuggestion = (suggestion, {query, isHighlighted}) => {
            const matches = match(suggestion.name, query);
            const parts = parse(suggestion.name, matches);

            return (
                <MenuItem selected={isHighlighted} component="div">
                    <div className={classes.suggestionItem}>
                        <div className={classes.suggestionCompanyName}>
                            {parts.map(part => (
                                <span key={part.text} style={{fontWeight: part.highlight ? 500 : 400}}>
            {part.text}
          </span>
                            ))}
                        </div>
                        <div className={classes.suggestionBusinessId}>
                            {suggestion.business_id}
                        </div>
                    </div>
                </MenuItem>
            );
        }

        const autosuggestProps = {
            renderInputComponent,
            suggestions: stateSuggestions,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            getSuggestionValue,
            renderSuggestion,
            onSuggestionSelected: this.onSuggestionSelected
        };

        return (
            <div className={classes.root}>
                <Autosuggest
                    {...autosuggestProps}
                    inputProps={{
                        classes,
                        id: 'react-autosuggest-simple',
                        label: 'Yrityksen nimi *',
                        placeholder: 'Ehdotan vaihtoehtoja',
                        value: single,
                        onChange: this.handleChange('single'),
                    }}
                    theme={{
                        container: classes.container,
                        suggestionsContainerOpen: classes.suggestionsContainerOpen,
                        suggestionsList: classes.suggestionsList,
                        suggestion: classes.suggestion,
                    }}
                    renderSuggestionsContainer={options => (
                        <Paper {...options.containerProps} square>
                            {options.children}
                        </Paper>
                    )}
                />
            </div>
        );
    }
}

export default withStyles(styles)(AutoSuggest);
